<template>
  <v-container>
    <h2>Potential Users</h2>
    <app-base ref="crud" :source="getPotentialUsers" :tableHeader="headers" />
  </v-container>
</template>
<script>
import Base from "./Base.vue";
import { getPotentialUsers } from "@/api/api";

export default {
  components: {
    appBase: Base,
  },
  data() {
    return {
      name: "",
      getPotentialUsers,
      headers: [
        { text: "Name", value: "name", align: "left" },
        { text: "Email", value: "email", align: "right" },
        { text: "Phone", value: "phone_number", align: "center" },
        { text: "Created At", value: "created_at", align: "right" },
      ],
    };
  },
};
</script>
